import { z } from 'zod';
import { create } from 'zustand';

const PanelTypeSchema = z.enum(['contact', 'message', 'search', 'search-by-session']);
export type PanelType = z.infer<typeof PanelTypeSchema>;
export interface LayoutStore {
  panel: PanelType;
}

export const useLayoutStore = create<LayoutStore>(() => ({
  panel: 'message',
}));

export const setPanel = (panel: PanelType) => {
  useLayoutStore.setState((state) => ({ ...state, panel }));
};
